import { axiosClient } from "./axiosClient";
import { CONSENT_ENDPOINTS, AA_ENDPOINTS } from "./endpoints";

import {
    ConsentSubmitRequest,
    ConsentRejectRequest,
    GetConsentHandleRequest,
    ConsentSubmitResponse,
    SelfConsentDefaultRequest,
    SelfConsentRequest,
    ConsentStatusRequest,
} from "./api.types";

export const getConsentHandle = async (payload: GetConsentHandleRequest) => {
    const res = await axiosClient.post(
        CONSENT_ENDPOINTS.HANDLE,
        payload
    );
    return res.data;
};

export const generateConsentHandle = async (payload: any) => {
    const res = await axiosClient.post(
        AA_ENDPOINTS.CONSENT,
        payload
    );
    return res.data;
};

export const submitConsent = async (payload: ConsentSubmitRequest) => {
    const res = await axiosClient.post<ConsentSubmitResponse>(
        CONSENT_ENDPOINTS.SUBMIT,
        payload
    );
    return res.data;
};

export const rejectConsent = async (payload: ConsentRejectRequest) => {
    const res = await axiosClient.post(
        CONSENT_ENDPOINTS.REJECT,
        payload
    );
    return res.data;
};

export const getConsentList = async (payload: { I_MOBILENUMBER: string; I_SESSION: string; I_USERID: string }) => {
    const res = await axiosClient.post(
        CONSENT_ENDPOINTS.LIST,
        payload
    );
    return res.data;
};



export const getSelfConsentDefault = async (payload: SelfConsentDefaultRequest) => {
    const res = await axiosClient.post(
        CONSENT_ENDPOINTS.SELF_CONSENT_DEFAULT,
        payload
    );
    return res.data;
};

export const submitSelfConsent = async (payload: SelfConsentRequest) => {
    const res = await axiosClient.post(
        CONSENT_ENDPOINTS.SELF_CONSENT,
        payload
    );
    return res.data;
};

export const getConsentStatus = async (payload: ConsentStatusRequest) => {
    const res = await axiosClient.post(
        CONSENT_ENDPOINTS.CONSENT_STATUS,
        payload
    );
    return res.data;
};
